export function invertObject<T extends Record<string | number, string | number>>(source: T) {
	const result: Record<T[keyof T], keyof T> = {} as any;
	for (const [key, value] of Object.entries(source)) {
		result[value as T[keyof T]] = key as keyof T;
	}
	return result;
}
